
import React from 'react'
import PAGE_TITLES from '../../consts/titles'
import CustomHeader from '../../components/CustomHeader'
import SkipNavigation from '../../components/SkipNavigation'
import SurveyPreviewFeature from '../../features/SurveyPreview'

const SurveyPreviewPage: React.FC = (): JSX.Element => {
  return (
    <>
      <SkipNavigation />
      <CustomHeader title={PAGE_TITLES.SURVEYS} />
      <SurveyPreviewFeature/>
    </>
  )
}

export default SurveyPreviewPage
